import api from "../api";

async function inscreverAluno(aluno) {
  try {
    const resultado = await api.post(
      `/br.edu.unipam.campanha.api/api/v1/ClubeDiplomado/InscricaoAluno`,
      aluno
    );

    return resultado.data;
  } catch (error) {
    return [];
  }
}

async function inscreverParceiro(parceiro) {
  try {
    const resultado = await api.post(
      `/br.edu.unipam.campanha.api/api/v1/ClubeDiplomado/InscricaoParceiro`,
      parceiro
    );

    return resultado.data;
  } catch (error) {
    return [];
  }
}

export { inscreverAluno, inscreverParceiro };
